import React, { useEffect } from "react";
import { useForm } from "react-hook-form"; // Import useForm from react-hook-form
import { PatchRequest } from "../../../Api/ApiFunctions";
import { ApiUrl } from "../../../Api/EndPoints";
// import { Modal } from "react-bootstrap";

const EditContactUs = ({ OnFinish, editData }) => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { isSubmitting },
  } = useForm();

  useEffect(() => {
    if (editData) {
      setValue("id", editData.id);
      setValue("heading", editData.heading);
      setValue("email", editData.email);
      setValue("address1", editData.address1);
      setValue("address2", editData.address2);
      setValue("phone", editData.phone);
    }
  }, [editData, setValue]);

  const onSubmit = async (data) => {
    const resp = await PatchRequest(`${ApiUrl.configuration}/${editData.id}`, {
      value: JSON.stringify({
        heading: data.heading,
        email: data.email,
        address1: data.address1,
        address2: data.address2,
        phone: data.phone,
      }),
    });

    const closeButton = document.querySelector(
      '#edit-units [data-bs-dismiss="modal"]'
    );

    if (resp && closeButton) {
      closeButton.click();
      OnFinish();
      reset();
    }
  };

  return (
    <div>
      {/* Edit Unit */}
      <div className="modal fade" id="edit-units">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Edit Contact Us</h4>
                  </div>
                  <button
                    id="closebutton"
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    {/* <div className="mb-3">
                      <label className="form-label">Key</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="key for contact us Map"
                        {...register("key", {
                          required: "name is required",
                        })}
                      />
                    </div> */}
                    <div className="mb-3">
                      <label className="form-label">Heading</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("heading", {
                          required: "name is required",
                        })}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        {...register("email")}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Address 1</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("address1")}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Address 2</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("address2")}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Phone</label>
                      <input
                        type="text"
                        className="form-control"
                        {...register("phone")}
                      />
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <span className="spinner-border spinner-border-sm"></span>
                        ) : (
                          "Save Details"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditContactUs;
